import axios from "axios";
export const baseURL = "api.babylon2k.org";

const api = axios.create({
  baseURL: "https://api.babylon2k.org",
});

export default api;
